/*
 * Theme toggle (light/dark). Mirrors FozDigital's pattern:
 * - Default = system preference (no attribute set on <html>).
 * - Click sets `data-color-mode` on <html> and persists to localStorage.
 * - Pre-paint script in Header.php applies the persisted choice before
 *   first render to avoid FOUC.
 * - If the user has no explicit choice, the page follows OS theme
 *   changes live.
 *
 * Wired toggles:
 *   - Footer eco-mode checkbox (`#footerDarkModeToggle`) — checked = dark
 *   - Mobile menu checkbox (`#darkModeToggle`)            — checked = dark
 *   - Desktop button (`#desktopDarkModeToggle`)           — click flips
 */

(function () {
  const STORAGE_KEY = 'bfwt-color-mode';
  const root = document.documentElement;
  const mql = window.matchMedia('(prefers-color-scheme: dark)');

  function currentTheme() {
    const explicit = root.getAttribute('data-color-mode');
    if (explicit === 'dark' || explicit === 'light') return explicit;
    return mql.matches ? 'dark' : 'light';
  }

  function setTheme(theme) {
    root.setAttribute('data-color-mode', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {}
    document.cookie =
      'theme=' + theme + '; path=/; max-age=31536000; Secure; SameSite=Lax';
    syncToggles();
    window.dispatchEvent(
      new CustomEvent('bfwt:themechange', { detail: { theme } })
    );
    if (typeof window.bfwt_trackEvent === 'function') {
      window.bfwt_trackEvent('theme_toggle', {
        theme: theme,
        event_category: 'settings',
      });
    }
    if (window.BFWT_Accessibility) {
      window.BFWT_Accessibility.announce('Theme set to ' + theme + ' mode');
    }
  }

  function syncToggles() {
    const checked = currentTheme() === 'dark';
    document
      .querySelectorAll('#darkModeToggle, #footerDarkModeToggle, #bfwt-theme-checkbox')
      .forEach((el) => {
        el.checked = checked;
      });
  }

  function attachEvents() {
    document
      .querySelectorAll('#darkModeToggle, #footerDarkModeToggle, #bfwt-theme-checkbox')
      .forEach((el) => {
        el.addEventListener('change', () => {
          setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
        });
      });
    const desktopBtn = document.getElementById('desktopDarkModeToggle');
    if (desktopBtn) {
      desktopBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
      });
    }
  }

  // Follow OS changes when no explicit choice has been made.
  mql.addEventListener('change', () => {
    if (!root.hasAttribute('data-color-mode')) syncToggles();
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncToggles();
    attachEvents();
  });
})();
